export const version = { buildDate: '04.11.2026 14:06' };